var _path, _path2, _path3, _ellipse, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 34C15.94 34 9 30.154 9 24V14h31v10c0 5.171-6.94 10-15.5 10Z",
    fill: "#203442",
    className: "fill-203442"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.171 9.991 27.3.764a7.518 7.518 0 0 0-6.6 0L1.829 9.991a3.26 3.26 0 0 0 .15 5.927L4.5 17l16.543 7.079a7.517 7.517 0 0 0 5.914 0L43.5 17l2.521-1.078a3.26 3.26 0 0 0 .15-5.931Z",
    fill: "#653dae",
    className: "fill-4c5665"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 38a1 1 0 0 1-1-1V19.361L24.918 12.14a1 1 0 1 1 .914-1.78L41 18.139V37a1 1 0 0 1-1 1Z",
    fill: "#ecf0f1",
    className: "fill-ecf0f1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 11,
    rx: 4.5,
    ry: 3,
    fill: "#203442",
    className: "fill-203442"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 39,
    r: 4,
    fill: "#face53",
    className: "fill-face53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.1510e23e60a33705e0d5ff37d3219720.svg";
export { ForwardRef as ReactComponent };